import { render, staticRenderFns } from "./SkupStavkaImportExcelForm.vue?vue&type=template&id=50af98ac&scoped=true&"
import script from "./SkupStavkaImportExcelForm.vue?vue&type=script&lang=js&"
export * from "./SkupStavkaImportExcelForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50af98ac",
  null
  
)

export default component.exports